import { gettext } from '@eventbrite/i18n';
import { trackAnalyticsEvent } from '@eventbrite/site-analytics';
import React from 'react';
import { TrackingContext } from '../../../../trackingContext';
import { isLanguageSubfolderUsedForLocale } from '../../../../utils/location';
import { generateSearchUrl } from '../../../../utils/url';
import { CategoryBrowseBucket } from '../../components/CategoryBrowseBucket';
import { TagCloud, TagCloudBubble } from '../../components/TagCloud';
import { Item } from '../../components/TagCloud/TagCloud';
import { useSearchContext } from '../../context';
import { useRandomOrganizerTags } from '../../hooks/queries/aggregations';
import { useLocation } from '../../hooks/queries/location';

export const CategoryBrowseOrganizerTags: React.FunctionComponent = () => {
    const localeContext = React.useContext(TrackingContext);

    const { data: organizerTags } = useRandomOrganizerTags();
    const { data: location } = useLocation();
    const { query: currentQuery } = useSearchContext();

    if (!organizerTags || !location || !organizerTags?.length) {
        return null;
    }

    const handleClick = (
        item: Item<{
            display_name: string;
            key: string;
        }>,
    ) => {
        trackAnalyticsEvent({
            category: 'category-page',
            action: 'CreatorTagClicked',
            label: item.display_name,
        });
    };

    return (
        <CategoryBrowseBucket
            title={gettext('Trending event tags in your area')}
        >
            <TagCloud items={organizerTags}>
                {(item) => (
                    <a
                        key={item.key}
                        href={generateSearchUrl({
                            currentQuery: {
                                ...currentQuery,
                                q: `#${item.key}`,
                            },
                            locationSlug: location.slug,
                            usesLanguageSubdirectory:
                                isLanguageSubfolderUsedForLocale(
                                    localeContext.locale,
                                ),
                            locale: localeContext.locale,
                        })}
                        onClick={() => {
                            handleClick(item);
                        }}
                        rel="nofollow"
                        style={{ zIndex: 1 }}
                    >
                        <TagCloudBubble size={item.size || 'medium'}>
                            {`#${item.display_name}`}
                        </TagCloudBubble>
                    </a>
                )}
            </TagCloud>
        </CategoryBrowseBucket>
    );
};
